import type { ApiShift, Shift } from '@/api/shifts';

/**
 * Marks each person's shifts that run back to back (the next punched in when the last punched out,
 * or earlier) with their stint, so worked() takes one automatic break for the stint, as pay does
 * (admin/shiftController.js autoBreakStints, 2026-10-06). A shift on its own is returned as it was.
 * The shift hooks apply it to every list they answer, so each screen counts the same way.
 */
export function markStints(shifts: ApiShift[]): Shift[] {
  const at = (v: string | null | undefined) => (v ? Date.parse(v) : Number.NaN);
  const byUser = new Map<number | null | undefined, { s: ApiShift; a: number; b: number }[]>();
  for (const s of shifts) {
    const a = at(s.punch_in_time);
    const b = at(s.punch_out_time);
    if (!(b > a)) continue;
    const list = byUser.get(s.user_id) ?? [];
    list.push({ s, a, b });
    byUser.set(s.user_id, list);
  }
  const stintOf = new Map<ApiShift, { start: number; end: number; n: number }>();
  for (const list of byUser.values()) {
    list.sort((x, y) => x.a - y.a);
    let cur: { start: number; end: number; n: number } | null = null;
    for (const x of list) {
      if (cur && x.a <= cur.end) {
        cur.end = Math.max(cur.end, x.b);
        cur.n += 1;
      } else cur = { start: x.a, end: x.b, n: 1 };
      stintOf.set(x.s, cur);
    }
  }
  return shifts.map((s) => {
    const st = stintOf.get(s);
    return st && st.n > 1 ? { ...s, stint: { start: st.start, end: st.end } } : s;
  });
}
